<template>
  <div class="tenant-subscribe">
    <ContentBlock style="padding: 0 10px 84px 10px;">
      <div class="topTitleContainer">
        <span>状态
          <el-radio-group v-model="outform.openBizOppSubFlag" @change="handleSearch" style="margin-left: 14px;">
            <el-radio-button :label="null">全部({{totalCount}})</el-radio-button>
            <el-radio-button :label="true">已订阅({{openCount}})</el-radio-button>
            <el-radio-button :label="false">未订阅({{closeCount}})</el-radio-button>
          </el-radio-group>
        </span>
      </div>
      <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :toolBar="toolBar" :sortInfo.sync="sortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination" @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="getTargetLists" :highHoverRow="false" :highlightRow="false" :leftToolbar="tableButtons" />
    </ContentBlock>
    <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="用户名称">
              <el-input placeholder="请输入用户名称" v-model.trim="form.tenantName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="企业编号">
              <el-input placeholder="请输入企业编号" v-model.trim="form.tenantCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="最后订阅时间">
              <el-date-picker
                v-model="lastSubTime"
                @change="handleChangeTime($event, 'lastSubTime')"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>

    <!-- 商机订阅明细弹窗 -->
    <SubscribeDetailDialog v-if="detailDialogVisible" :dialog-visible.sync="detailDialogVisible" :currentDetail="currentDetail"></SubscribeDetailDialog>
  </div>
</template>
<script>
import * as dayjs from 'dayjs';
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getBizOppSubTenantPageList, exportBizOppSubTenantDetail, getBizOppSubTenantCount } from '@/api/niche';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import SubscribeDetailDialog from '../components/subscribeDetailDialog';

export default {
  name: 'SAAS_NICHE_TENANT_SUBSCRIBE_LIST',
  components: {
    TableWithPagination,
    SubscribeDetailDialog,
  },
  mixins: [TablePaginationMixin],
  computed: {
    tableButtons () {
      return [
        {
          name: '导出',
          status: 'primary',
          size: 'small',
          code: 'exportExcel',
          disabled: this.isLoading,
          loading: this.isLoading,
          // permission: '', // 权限码
          click: this.handleExport,
        },
      ];
    },
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入用户名称' style='width:250px;' v-model={this.form.tenantName}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '用户名称',
          minWidth: '150px',
          width: '',
          key: 'tenantName',
          prop: 'tenantName',
        },
        {
          tooltip: true,
          label: '企业编号',
          minWidth: '100px',
          width: '',
          key: 'tenantCode',
          prop: 'tenantCode',
        },
        {
          tooltip: true,
          label: '订阅状态',
          minWidth: '120px',
          width: '',
          key: 'openBizOppSubFlag',
          prop: 'openBizOppSubFlag',
          format: (v) => {
            return v === true ? '已订阅' : v === false ? '未订阅' : '--';
          },
        },
        {
          tooltip: true,
          label: '最后订阅时间',
          minWidth: '150px',
          width: '',
          key: 'lastSubTime',
          prop: 'lastSubTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
      ];

      cols.push({
        label: '操作',
        prop: 'action',
        width: '70px',
        fixed: 'right',
        render: (h, { row }) => {
          let actions = [];
          actions.push(h('span', {
            domProps: {
              className: 'table-action',
            },
            on: {
              click: () => { this.handleDetail(row); },
            },
          }, '详情'));
          return h('div', actions);
        },
      });

      return cols;
    },
  },
  data () {
    return {
      form: {
        tenantCode: '',
        tenantName: '',
        lastSubTimeStart: '',
        lastSubTimeEnd: '',
      },
      outform: {
        openBizOppSubFlag: null,
      },
      lastSubTime: [],
      targetLists: [],
      isShow: false,
      isLoading: false,
      detailDialogVisible: false,
      currentDetail: {},
      totalCount: 0,
      openCount: 0,
      closeCount: 0,
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    handleChangeTime (v, type) {
      if (!v || v.length === 0) {
        this.form[type + 'Start'] = '';
        this.form[type + 'End'] = '';
      } else {
        this.form[type + 'Start'] = v[0] + ' 00:00:00';
        this.form[type + 'End'] = v[1] + ' 23:59:59';
      }
    },
    handleDetail (v) {
      // 查看详情弹窗
      this.currentDetail = v || {};
      this.detailDialogVisible = true;
    },
    handleQuery () {
      this.pagination.currentPage = 1;

      this.getTargetLists();

      this.$nextTick(() => {
        this.isShow = false;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleAdvancedSearch () {
      this.isShow = true;
    },
    handleReset () {
      this.handleEmpty();

      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.outform = this.$options.data().outform;
      this.lastSubTime = [];
    },
    getTargetLists () {
      const params = {
        ...this.form,
        ...this.outform,
        lastSubTimeStart: new Date(this.form.lastSubTimeStart || '').getTime() || '',
        lastSubTimeEnd: new Date(this.form.lastSubTimeEnd || '').getTime() || '',
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }

      getBizOppSubTenantPageList(params).then(({ body }) => {
        this.targetLists = body?.list || [];
        this.pagination.total = Number(body?.total || 0);
      });
      this.quryBizOppSubTenantCount();
    },
    quryBizOppSubTenantCount () {
      getBizOppSubTenantCount({}).then(({ body }) => {
        this.openCount = Number(body?.openCount || 0);
        this.closeCount = Number(body?.closeCount || 0);
        this.totalCount = Number(body?.openCount || 0) + Number(body?.closeCount || 0);
      });
    },
    handleExport () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const params = {
        ...this.form,
        ...this.outform,
        lastSubTimeStart: new Date(this.form.lastSubTimeStart || '').getTime() || '',
        lastSubTimeEnd: new Date(this.form.lastSubTimeEnd || '').getTime() || '',
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }
      exportBizOppSubTenantDetail(params).then(res => {
        this.isLoading = false;
        let headerName = `商机订阅表_${dayjs().format('YYYYMMDDHHmmss')}`;
        let fileName = decodeURI(headerName);
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'}); // 注意你的文件类型，我的是excel，需要什么类型文件，对应修改即可
        // IE兼容
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          var a = document.createElement('a');
          a.download = fileName;
          a.href = URL.createObjectURL(blob);
          a.setAttribute('id', 'export');
          document.body.appendChild(a); // 修复firefox中无法触发click， platform 为我本页div 的id， 此处可直接用document.body
          a.click();
          document.getElementById('export').remove();
        }
      }).then(() => {
        this.isLoading = false;
      });
    },
  },
  created () {
    this.handleSearch();
  },
};
</script>
<style scoped lang='scss'>
/deep/ .topTitleContainer {
  height: 60px;
  background: #FFFFFF;
  box-shadow: inset 0px -1px 0px 0px #DFE2E8;
  border-radius: 6px 6px 0px 0px;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.tenant-subscribe {
  .flex {
    display: flex;
    align-items: center;
  }
}
/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}
</style>
